import icon20400904 from "@/assets/imgs/act/wc2026/item/20400904.png";
import icon20500901 from "@/assets/imgs/act/wc2026/item/20500901.png";
import icon32204003 from "@/assets/imgs/act/wc2026/item/32204003.png";
import icon70100011 from "@/assets/imgs/act/wc2026/item/70100011.png";
import icon70100004 from "@/assets/imgs/act/wc2026/item/70100004.png";
import icon70100014 from "@/assets/imgs/act/wc2026/item/70100014.png";
import icon70100101 from "@/assets/imgs/act/wc2026/item/70100101.png";
import icon80102101 from "@/assets/imgs/act/wc2026/item/80102101.png";
import icon81010999 from "@/assets/imgs/act/wc2026/item/81010999.png";
import icon90105303 from "@/assets/imgs/act/wc2026/item/90105303.png";
import icon90301905 from "@/assets/imgs/act/wc2026/item/90301905.png";
import icon90301906 from "@/assets/imgs/act/wc2026/item/90301906.png";



import icon90501207en from "@/assets/imgs/act/wc2026/item/90501207en.png";
import icon90501207vi from "@/assets/imgs/act/wc2026/item/90501207vi.png";
import icon90501207th from "@/assets/imgs/act/wc2026/item/90501207th.png";
import icon90501207id from "@/assets/imgs/act/wc2026/item/90501207id.png";
import icon90501207tw from "@/assets/imgs/act/wc2026/item/90501207tw.png";
import icon90501207hk from "@/assets/imgs/act/wc2026/item/90501207hk.png";


import icon90501208en from "@/assets/imgs/act/wc2026/item/90501208en.png";
import icon90501208vi from "@/assets/imgs/act/wc2026/item/90501208vi.png";
import icon90501208th from "@/assets/imgs/act/wc2026/item/90501208th.png";
import icon90501208id from "@/assets/imgs/act/wc2026/item/90501208id.png";
import icon90501208tw from "@/assets/imgs/act/wc2026/item/90501208tw.png";
import icon90501208hk from "@/assets/imgs/act/wc2026/item/90501208hk.png";



export const itemIcons = {
  20400904: icon20400904,
  20500901: icon20500901,
  32204003: icon32204003,
  70100011: icon70100011,
  70100004: icon70100004,
  70100014: icon70100014,
  70100101: icon70100101,
  80102101: icon80102101,
  81010999: icon81010999,
  90105303: icon90105303,
  90301905: icon90301905,
  90301906: icon90301906,
  '90501207en': icon90501207en,
  '90501207ph': icon90501207en,
  '90501207my': icon90501207en,
  '90501207sg': icon90501207en,
  '90501207vi': icon90501207vi,
  '90501207th': icon90501207th,
  '90501207id': icon90501207id,
  '90501207tw': icon90501207tw,
  '90501207hk': icon90501207hk,
  '90501208sg': icon90501208en,
  '90501208ph': icon90501208en,
  '90501208my': icon90501208en,
  '90501208en': icon90501208en,
  '90501208vi': icon90501208vi,
  '90501208th': icon90501208th,
  '90501208id': icon90501208id,
  '90501208tw': icon90501208tw,
  '90501208hk': icon90501208hk,

};

export const getItemIcon = (itemId, locale) => {
if(itemIcons[itemId]) {
  return itemIcons[itemId];
}
return itemIcons[itemId + locale];
}